<template>
	<ui-card
		icon="fal fa-users-class"
		title="Grupos de Usuários"
		text="Defina nomes personalizados para os grupos da sua empresa."
	>
		<template #body>
			<ui-load-success
				v-if="loader.overlay"
				:loading="loader.overlayLoading"
				:success="loader.overlaySucess"
			/>

			<div class="area-card">
				<transition name="small-fade">
					<div v-show="loader.body" class="loading-card">
						<ui-load-indicator bgColor="#e7e9f4" color="#69D296" :h="50" :stroke="8" />
					</div>
				</transition>

				<ui-input
					v-model="form.admin"
					:disabled="disabled.admin"
					placeholder="Administrador"
					label="Administrador:"
					type="text"
				/>

				<div class="grid-50">
					<ui-input
						v-model="form.collaborator"
						:disabled="disabled.collaborator"
						placeholder="Colaborador"
						label="Colaborador:"
						type="text"
					/>

					<ui-input
						v-model="form.supervisor"
						:disabled="disabled.supervisor"
						placeholder="Supervisor"
						label="Supervisor:"
						type="text"
					/>
				</div>

				<div class="grid-50">
					<ui-input
						v-model="form.manager"
						:disabled="disabled.manager"
						placeholder="Gerente"
						label="Gerente:"
						type="text"
					/>

					<ui-input
						v-model="form.broker"
						:disabled="disabled.broker"
						placeholder="Colaborador"
						label="Colaborador:"
						type="text"
					/>
				</div>
			</div>
		</template>
		<template #fl></template>
		<template #fr>
			<ui-button design="md success" :disabled="!canSubmit" @click="submit"
				>Salvar Grupos</ui-button
			>
		</template>
	</ui-card>
</template>
<script>
	import { uiCard } from '@/components/ui/cards'
	import { uiButton } from '@/components/ui/buttons'
	import { uiInput } from '@/components/ui/form'
	import { uiLoadIndicator } from '@/components/ui'
	import { uiLoadSuccess } from '@/components/ui/overlays'

	import { utilMixin, formMixin, alertMixin } from '@/mixins'
	import { getConfig, saveConfig } from '../../util/methods'

	const defaultForm = () => ({
		admin: null,
		collaborator: null,
		supervisor: null,
		manager: null,
		broker: null,
	})

	const defaultDisabled = () => ({
		admin: false,
		collaborator: false,
		supervisor: false,
		manager: false,
		broker: false,
	})

	const defaultLoader = () => ({
		body: false,
		overlay: false,
		overlayLoading: true,
		overlaySucess: true,
	})

	export default {
		name: 'configuration-users-general',

		components: { uiCard, uiButton, uiInput, uiLoadSuccess, uiLoadIndicator },

		mixins: [utilMixin, formMixin, alertMixin],

		async created() {
			this.loader.body = true

			const [labelAdmin, labelCollaborator, labelSupervisor, labelManager, labelBroker] =
				await Promise.all([
					this.getConfig('labelAdmin'),
					this.getConfig('labelCollaborator'),
					this.getConfig('labelSupervisor'),
					this.getConfig('labelManager'),
					this.getConfig('labelBroker'),
				])

			this.form.admin = labelAdmin
			this.form.collaborator = labelCollaborator
			this.form.supervisor = labelSupervisor
			this.form.manager = labelManager
			this.form.broker = labelBroker

			this.loader.body = false

			this.$mx_copyOldForm()
			this.disabled.name = false
		},

		data() {
			return {
				form: { ...defaultForm() },
				disabled: { ...defaultDisabled() },
				loader: { ...defaultLoader() },
				oldForm: {},
			}
		},

		computed: {
			canSubmit() {
				return (
					this.$mx_isFormChanged &&
					!!this.form.admin &&
					!!this.form.collaborator &&
					!!this.form.supervisor &&
					!!this.form.manager &&
					!!this.form.broker &&
					!this.loader.body
				)
			},
		},

		methods: {
			getConfig,
			saveConfig,

			async submit() {
				try {
					this.loader.overlay = true
					this.loader.overlayLoading = true

					await Promise.all([
						this.saveConfig('labelAdmin', this.form.admin),
						this.saveConfig('labelCollaborator', this.form.collaborator),
						this.saveConfig('labelSupervisor', this.form.supervisor),
						this.saveConfig('labelManager', this.form.manager),
						this.saveConfig('labelBroker', this.form.broker),
					])

					setTimeout(() => {
						this.loader.overlayLoading = false
						this.loader.overlaySucess = true
						setTimeout(() => {
							this.loader.overlay = false
						}, 500)
					}, 500)

					this.$mx_copyOldForm()
					//...
				} catch (error) {
					this.$mx_alertThisOnError(error)
					this.loader.overlaySucess = false
					setTimeout(() => {
						this.loader.overlay = false
					}, 1000)
				}
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
